module.exports = __webpack_public_path__ + "img/grey-tray-arrow-down.6b0ae3cb.svg";